import { AfterViewInit, Component, ElementRef, Inject, ViewChild } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { take } from 'rxjs/operators'

import { EditDialogDataModel } from 'src/app/views/companies/model'
import { BaseEditDialogComponent } from '../base-edit-dialog/base-edit-dialog.component'
import { FormGeneratorService, FormType } from '../tree/services/form-generator/form-generator.service'

@Component({
  selector: 'app-condition-edit-dialog',
  templateUrl: './condition-edit-dialog.component.html',
  styleUrls: [
    '../base-edit-dialog/base-edit-dialog.component.scss',
    './condition-edit-dialog.component.scss'
  ]
})
export class ConditionEditDialogComponent extends BaseEditDialogComponent implements AfterViewInit {
  formType: FormType = 'condition'

  @ViewChild('nameInput', { read: ElementRef }) nameInput: ElementRef<HTMLInputElement>

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: EditDialogDataModel,
    public dialogRef: MatDialogRef<ConditionEditDialogComponent>,
    formGenerator: FormGeneratorService) {
    super(data, dialogRef, formGenerator)
  }

  ngAfterViewInit(): void {
    const opened$ = (this.dialogRef as any)?.afterOpened?.()
    if (!opened$) {
      return
    }

    opened$.pipe(take(1)).subscribe(() => {
      setTimeout(() => {
        this.nameInput?.nativeElement?.focus()
      }, 0)
    })
  }

}
